import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {Col, Row} from "antd";
import {
	DateField,
	InputPriceField,
} from "~/components/Forms";

function ServiceFormEdit({item, onHandleSubmit}) {

	const initialValues = {
		expired: (item.expired*1000),
		price: item.price,
	}

	const validationSchema = Yup.object().shape({
		expired: Yup.string().required('Bạn chưa chọn ngày hết hạn'),
		price: Yup.number().required('Giá trị gia hạn không được để trống'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Thông tin </p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="expired" render={({ field }) => (
						<DateField type="text" label="Ngày hết hạn" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="price" render={({field}) => (
						<InputPriceField label="Phí gia hạn" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật</Button>
			</div>
		</form>
	)
}

export default ServiceFormEdit;